import React from "react";

import DetailsForm from "./DetailsForm";
import LearningObjectivesForm from "./LearningObjectivesForm";
import QuestionsForm from "./QuestionsForm";
import useFormsPresenter from "@Totum/QuestionnaireBuilder/Presentation//hooks/useFormsPresenter";
import FormSkeleton from "./skeletons/FormSkeleton";

const Forms = () => {
    const { uiModel } = useFormsPresenter();

    if (!uiModel.canShowDetailsForm) {
        return null;
    }

    if (uiModel.shouldShowSkeleton) {
        return <FormSkeleton />;
    }

    return (
        <>
            <DetailsForm />
            {uiModel.canShowAllForms ? (
                <>
                    <LearningObjectivesForm />
                    <QuestionsForm />
                </>
            ) : null}
        </>
    );
};

export default Forms;
